{
  "clinicalNotes": "चिकित्सा नोट्स",
  "noteType": "नोट प्रकार",
  "author": "लेखक",
  "dateTime": "दिनांक/समय",
  "content": "विषय-वस्तु",
  "addNote": "नोट जोड़ें",
  "editNote": "नोट संपादित करें",
  "signNote": "नोट हस्ताक्षर करें",
  "signed": "हस्ताक्षरित",
  "unsigned": "अहस्ताक्षरित",
  "types": {
    "progressNote": "प्रगति नोट",
    "admissionNote": "प्रवेश नोट",
    "dischargeNote": "छुट्टी नोट",
    "consultNote": "परामर्श नोट",
    "procedureNote": "प्रक्रिया नोट"
  },
  "editor": {
    "newNote": "नया नोट",
    "titlePlaceholder": "नोट शीर्षक…",
    "create": "बनाएँ",
    "cancel": "रद्द करें",
    "cosignFilterLabel": "केवल मेरे सह-हस्ताक्षर वाले नोट दिखाएँ",
    "emptyNoCosign": "आपके सह-हस्ताक्षर हेतु कोई नोट नहीं",
    "emptyNoNotes": "अभी कोई नोट नहीं",
    "emptySelection": "कोई नोट चुनें या नया बनाएँ",
    "emptySelectionHint": "बाईं सूची से चुनें या \"+ नया नोट\" क्लिक करके आरंभ करें।",
    "unknownAuthor": "अज्ञात",
    "needsCosignBadge": "सह-हस्ताक्षर चाहिए",
    "amendmentBanner": "नोट #{{parentId}} का संशोधन — कारण: {{reason}}",
    "signedBanner": "{{name}} द्वारा {{when}} को हस्ताक्षरित — यह नोट केवल-पठनीय है।",
    "signedByFallback": "चिकित्सक",
    "saving": "सहेजा जा रहा है…",
    "autoSaved": "स्वतः सहेजा गया",
    "actions": {
      "saveDraft": "ड्राफ्ट सहेजें",
      "signNote": "नोट हस्ताक्षर करें",
      "amend": "संशोधन",
      "cosign": "सह-हस्ताक्षर",
      "printLabel": "नोट प्रिंट करें"
    },
    "copyForward": "पिछला नोट आगे ले जाएँ",
    "copyForwardHint": "{{date}} का हस्ताक्षरित नोट लाया जाएगा — हर पंक्ति की समीक्षा करें",
    "copiedForwardBadge": "आगे लाया गया"
  },
  "dialog": {
    "sign": {
      "title": "नोट हस्ताक्षर करें",
      "body": "क्या आप इस नोट पर हस्ताक्षर करना चाहते हैं? यह क्रिया वापस नहीं ली जा सकती। हस्ताक्षर के बाद नोट केवल-पठनीय हो जाएगा।",
      "cancel": "रद्द करें",
      "confirm": "हस्ताक्षर की पुष्टि"
    },
    "amend": {
      "title": "नोट संशोधन",
      "body": "कृपया इस संशोधन का कारण बताएँ। नोट अद्यतन होगा और संशोधित के रूप में चिन्हित होगा।",
      "reasonPlaceholder": "संशोधन का कारण…",
      "cancel": "रद्द करें",
      "confirm": "संशोधन की पुष्टि"
    },
    "cosign": {
      "title": "नोट पर सह-हस्ताक्षर",
      "body": "क्या आप इस नोट पर सह-हस्ताक्षर करना चाहते हैं? यह दर्शाता है कि आपने नोट की सामग्री देखी और सहमत हैं।",
      "cancel": "रद्द करें",
      "confirm": "सह-हस्ताक्षर की पुष्टि"
    }
  },
  "toast": {
    "created": "नोट बना दिया गया",
    "createFailed": "नोट बनाने में विफलता",
    "titleRequired": "कृपया नोट का शीर्षक दर्ज करें",
    "draftSaved": "ड्राफ्ट सहेजा गया",
    "signed": "नोट सफलतापूर्वक हस्ताक्षरित",
    "signFailed": "नोट हस्ताक्षर करने में विफलता",
    "amended": "नोट सफलतापूर्वक संशोधित",
    "amendFailed": "नोट संशोधित करने में विफलता",
    "amendReasonRequired": "कृपया संशोधन का कारण बताएँ",
    "cosigned": "नोट पर सह-हस्ताक्षर सफल",
    "cosignFailed": "नोट पर सह-हस्ताक्षर विफल"
  },
  "status": {
    "draft": "ड्राफ्ट",
    "unsigned": "अहस्ताक्षरित",
    "signed": "हस्ताक्षरित",
    "amended": "संशोधित",
    "cosigned": "सह-हस्ताक्षरित",
    "cosignNeeded": "सह-हस्ताक्षर अपेक्षित",
    "pendingSignature": "हस्ताक्षर लंबित",
    "addendum": "परिशिष्ट",
    "cosignPending": "सह-हस्ताक्षर लंबित"
  },
  "worklist": {
    "title": "अहस्ताक्षरित नोट कार्यसूची",
    "backToDashboard": "डैशबोर्ड",
    "filtersHeading": "फ़िल्टर",
    "filterAllNoteTypes": "सभी नोट प्रकार",
    "filterAllStatuses": "सभी स्थितियाँ",
    "filterAuthorPlaceholder": "लेखक द्वारा फ़िल्टर…",
    "dateFromAria": "प्रारंभ तिथि",
    "dateToAria": "अंत तिथि",
    "columns": {
      "patient": "रोगी",
      "mrn": "MRN",
      "noteType": "नोट प्रकार",
      "noteTitle": "शीर्षक",
      "author": "लेखक",
      "created": "निर्मित",
      "status": "स्थिति",
      "actions": "क्रियाएँ"
    },
    "actions": {
      "signSelected": "चयनित पर हस्ताक्षर ({{count}})",
      "signing": "हस्ताक्षर कर रहे हैं…",
      "open": "खोलें",
      "refresh": "रिफ़्रेश"
    },
    "loading": "नोट लोड हो रहे हैं…",
    "empty": "कोई अहस्ताक्षरित नोट नहीं मिला",
    "loadError": "अहस्ताक्षरित नोट लोड करने में विफल",
    "retry": "पुनः प्रयास",
    "toast": {
      "noneSelected": "कोई नोट चयनित नहीं",
      "signed_one": "{{count}} नोट सफलतापूर्वक हस्ताक्षरित",
      "signed_other": "{{count}} नोट सफलतापूर्वक हस्ताक्षरित",
      "signFailed": "कुछ नोट पर हस्ताक्षर विफल",
      "partiallySigned_one": "{{count}} नोट पर हस्ताक्षर हुआ, {{failed}} विफल",
      "partiallySigned_other": "{{count}} नोट पर हस्ताक्षर हुआ, {{failed}} विफल"
    }
  },
  "type": {
    "progress": "प्रगति नोट",
    "historyPhysical": "H&P",
    "admission": "प्रवेश नोट",
    "discharge": "डिस्चार्ज सारांश",
    "consult": "परामर्श",
    "procedure": "प्रक्रिया नोट",
    "operative": "ऑपरेटिव नोट",
    "nursing": "नर्सिंग नोट"
  },
  "template": {
    "list": {
      "title": "नोट टेम्पलेट",
      "backToDashboard": "डैशबोर्ड",
      "newButton": "नया टेम्पलेट",
      "columns": {
        "name": "नाम",
        "noteType": "नोट प्रकार",
        "specialty": "विशेषज्ञता",
        "sections": "अनुभाग",
        "status": "स्थिति",
        "actions": "क्रियाएँ"
      },
      "active": "सक्रिय",
      "inactive": "निष्क्रिय",
      "loading": "टेम्पलेट लोड हो रहे हैं…",
      "empty": "कोई टेम्पलेट नहीं मिला। आरंभ करने के लिए एक बनाएँ।",
      "previewTitle": "टेम्पलेट पूर्वावलोकन: {{name}}",
      "emptySection": "(रिक्त)",
      "tooltips": {
        "preview": "पूर्वावलोकन",
        "edit": "संपादित",
        "activate": "सक्रिय करें",
        "deactivate": "निष्क्रिय करें"
      },
      "toast": {
        "statusUpdated": "टेम्पलेट स्थिति अद्यतन"
      }
    },
    "form": {
      "editTitle": "टेम्पलेट संपादन",
      "createTitle": "टेम्पलेट निर्माण",
      "fields": {
        "name": "टेम्पलेट का नाम",
        "noteType": "नोट प्रकार",
        "specialty": "विशेषज्ञता",
        "sections": "अनुभाग"
      },
      "required": "*",
      "namePlaceholder": "उदा., मानक प्रगति नोट",
      "selectNoteType": "प्रकार चुनें…",
      "selectSpecialty": "विशेषज्ञता चुनें…",
      "addSection": "अनुभाग जोड़ें",
      "sectionNamePlaceholder": "अनुभाग का नाम (उदा., मुख्य शिकायत)",
      "sectionDefaultPlaceholder": "इस अनुभाग की डिफ़ॉल्ट सामग्री…",
      "cancel": "रद्द करें",
      "create": "टेम्पलेट बनाएँ",
      "update": "टेम्पलेट अद्यतन",
      "toast": {
        "created": "टेम्पलेट बनाया गया",
        "updated": "टेम्पलेट अद्यतन हो गया",
        "saveFailed": "टेम्पलेट सहेजने में विफलता",
        "nameAndTypeRequired": "नाम और नोट प्रकार आवश्यक हैं",
        "atLeastOneSection": "कम से कम एक अनुभाग आवश्यक है"
      }
    },
    "specialty": {
      "general": "सामान्य",
      "internalMedicine": "आंतरिक चिकित्सा",
      "surgery": "शल्य चिकित्सा",
      "pediatrics": "बाल चिकित्सा",
      "cardiology": "हृदय रोग",
      "neurology": "तंत्रिका विज्ञान",
      "orthopedics": "अस्थि रोग",
      "emergencyMedicine": "आपातकालीन चिकित्सा"
    },
    "scope": {
      "personal": "व्यक्तिगत",
      "group": "समूह",
      "global": "संपूर्ण"
    },
    "state": {
      "draft": "ड्राफ्ट",
      "published": "प्रकाशित"
    }
  },
  "components": {
    "clinicalNoteEditor": {
      "bold": "बोल्ड",
      "italic": "इटैलिक",
      "list": "सूची",
      "templates": "टेम्पलेट / स्मार्ट वाक्यांश",
      "saved": "सहेजा गया {{time}}",
      "notSaved": "सहेजा नहीं गया",
      "charactersLabel": "वर्ण",
      "save": "{{noteType}} सहेजें",
      "placeholder": "अपना {{noteType}} टाइप करना शुरू करें… स्मार्ट वाक्यांश ट्रिगर करने के लिए \".\" का उपयोग करें।",
      "smartPhrases": {
        "patientName": "रोगी का नाम",
        "mrn": "एमआरएन",
        "dateOfBirth": "जन्म तिथि",
        "allergies": "एलर्जी",
        "vitals": "जीवन संकेत",
        "medications": "दवाएं",
        "problemList": "समस्या सूची"
      }
    }
  }
}
